import styles from './NextChargeCard.module.css';

interface NextChargeRow {
	label: string;
	value: string;
	emphasis?: boolean;
}

interface NextChargeCardProps {
	rows: NextChargeRow[];
}

export const NextChargeCard = ({ rows }: NextChargeCardProps) => {
	return (
		<section className={styles.card}>
			<h3 className={styles.title}>Próxima cobrança</h3>
			<ul className={styles.list}>
				{rows.map((row) => (
					<li key={row.label} className={styles.row}>
						<span className={styles.label}>{row.label}</span>
						<span className={`${styles.value} ${row.emphasis ? styles.emphasis : ''}`}>
							{row.value}
						</span>
					</li>
				))}
			</ul>
		</section>
	);
};
